<template>
  <v-container
    fluid
    class="main--text">
    <v-row>
      <v-col>
        <v-card>
          <v-container
            fluid
            >
            <v-row
              dense
              align=center>
              <v-icon>fa-search</v-icon>
              <v-col><h3>条件で絞り込む</h3></v-col>
            </v-row>
            <v-row
              align=center
              justify=center
              >
              <v-col
                cols=12
                sm=12
                md=auto
                class="font-weight-bold"
                >
                性別
              </v-col>
              <v-col
                cols=12
                md=10
                sm=12
                >
                <v-radio-group
                  v-model="gender"
                  row>
                  <v-radio
                    label="男性"
                    value="male">
                  </v-radio>
                  <v-radio
                    label="女性"
                    value="female">
                  </v-radio>
                  <v-radio
                    label="指定しない"
                    :value="false"
                    >
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row
              align=center
              justify=center>
              <v-col
                cols=12
                md=auto
                class="font-weight-bold">
                地域
              </v-col>
              <v-col
                cols=12
                md=10
                sm=12>
                <v-select
                  v-model="prefecture"
                  :items="prefectures"
                  label="都道府県"></v-select>
              </v-col>
            </v-row>
            <v-row
              align=center
              justify=center>
              <v-col
                cols=12
                md=auto
                class="font-weight-bold">
                曜日
              </v-col>
              <v-col
                cols=12
                md=10
                sm=12
                >
                <v-row
                  justify=space-around>
                  <v-checkbox v-model="availableDays" value="月" label="月"></v-checkbox>
                  <v-checkbox v-model="availableDays" value="火" label="火"></v-checkbox>
                  <v-checkbox v-model="availableDays" value="水" label="水"></v-checkbox>
                  <v-checkbox v-model="availableDays" value="木" label="木"></v-checkbox>
                  <v-checkbox v-model="availableDays" value="金" label="金"></v-checkbox>
                  <v-checkbox v-model="availableDays" value="土" label="土"></v-checkbox>
                  <v-checkbox v-model="availableDays" value="日" label="日"></v-checkbox>
                </v-row>
              </v-col>
            </v-row>
            <v-row
              justify=end
              no-gutters>
              <v-col
                cols=auto>
              <v-btn
                depressed
                rounded
                outlined
                color="primary"
                @click="$emit('search-button-click')">
                <span class="font-weight-bold">実行</span>
              </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { prefectures } from "@/models/Regions.js"

export default {
  props: {
    value: Object
  },
  data () {
    return {
      prefectures: prefectures,
    }
  },
  methods: {
    updateValue(diff) {
      this.$emit("input", { ...this.value, ...diff })
    }
  },
  computed: {
    gender: {
      get() {
        return this.value.gender
      },
      set(gender) {
        this.updateValue({ gender })
      }
    },
    prefecture: {
      get() {
        return this.value.prefecture
      },
      set(prefecture) {
        this.updateValue({ prefecture })
      }
    },
    availableDays: {
      get() {
        return this.value.availableDays
      },
      set(availableDays) {
        this.updateValue({ availableDays })
      }
    }
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>
